import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { GenericModal as GenericModal$2 } from './component.js';
import { GenericModal as GenericModal$1 } from './component.legacy.js';
import { convertLegacyModalSize } from '../../utils/legacyModalSize.js';

var convertButtonProps = function convertButtonProps(buttonConfig) {
  if (buttonConfig.saveAction) {
    buttonConfig.onClick = buttonConfig.saveAction;
  }

  if (!buttonConfig.label) {
    buttonConfig.label = buttonConfig.text || buttonConfig.saveText;
  }

  return buttonConfig;
};

var GenericModal = function GenericModal(props) {
  if (props.renderAsLegacy) {
    return /*#__PURE__*/React.createElement(GenericModal$1, props);
  } else {
    return /*#__PURE__*/React.createElement(GenericModal$2, _extends({}, props, {
      size: props.size && convertLegacyModalSize(props.size),
      footerCloseButton: props.footerCloseButton && convertButtonProps(props.footerCloseButton),
      saveButtonConfig: props.saveButtonConfig && convertButtonProps(props.saveButtonConfig)
    }));
  }
};

export { GenericModal };